export default __webpack_public_path__ + "static/media/visa.8f6fca94.svg";